import React, { Component } from 'react';
import { toast } from 'react-toastify';

import ConfirmModalV2 from '../ConfirmModalV2';
import FormError from 'components/FormError';

class ReactivateModal extends Component {
  state = {
    loading: false,
  }

  handleReactivate = () => {
    const { sub, closeModal, reactivateSub } = this.props;
    this.setState({ loading: true });
    return reactivateSub(sub.id)
      .then(() => {
        closeModal();
        toast.success("Subscription reactivation requested.");
      })
      .catch(e => {
        if (e.errors) {
          if (e.errors._error) {
            toast.error(<FormError error={e.errors._error}/>)
            return;
          }

          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach(key => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError}/>)
        } else {
          toast.error(<FormError error={e}/>)
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      })
  }

  render() {
    const { isOpen, closeModal } = this.props;
    const { loading } = this.state;
    return (
      <ConfirmModalV2
        isOpen={isOpen}
        onClose={closeModal}
        onConfirm={this.handleReactivate}
        loading={loading}
        confirmBtnText="Reactivate"
        title="Confirm Subscription Reactivation"
        text="Are you sure you want to reactivate subscription?"
      />
    )
  }
}


export default ReactivateModal;
